import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";
import FixedNavBar from "@/components/fixedNavBar";
import { Image, InfiniteScroll, PullToRefresh, SearchBar } from "antd-mobile";
import { DownFill } from "antd-mobile-icons";
import useRouter from "@/hooks/useRouter";
import API from "@/api";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import usePopup from "@/hooks/usePopup";
import SearchMembersList from "./comp/SearchMembersList";
import CustomEmpty from "@/components/Empty";
import useCustomTranslation from "@/hooks/useTranslation";
import LevelChen from "@/components/levelChen";
import { AgentListData } from "@/api/type";

const LowerMembers: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { customNavigate } = useRouter();
	const SearchMembersListPopup = usePopup();
	const [firstPage, setFirstPage] = useState(true);
	//  sort/默认根据创建时间倒序 1/根据余额排序
	const [bySortValue, setBySortValue] = useState(0);
	//   "sort": 10 //排序  10/默认你根据返佣比例 11/根据返佣
	const bySortList = [
		{
			sort: 10,
			name: "AccordingRebateRatio",
		},
		{
			sort: 11,
			name: "ByCommissionAmount",
		},
	];

	const [value, setValue] = useState("");
	const [data, setData] = useState<AgentListData[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 20;
	const postFinanceAgentListSearchHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
				nickname: value,
				sort: bySortList[bySortValue].sort,
			};

			const result: any = await API.finances.apiFinanceAgentList(params);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---apiFinanceAgentListSearch--:", error);
		}
	};
	const handleRefresh = async () => {
		await postFinanceAgentListSearchHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await postFinanceAgentListSearchHandle();
	};

	useEffect(() => {
		postFinanceAgentListSearchHandle();
	}, []);

	const onSubmitHandle = (value: number) => {
		setBySortValue(value);
		SearchMembersListPopup.closePopup();
	};

	useEffect(() => {
		if (!firstPage) handleRefresh();
		setFirstPage(false);
	}, [bySortValue]);

	return (
		<div className="router-main">
			<FixedNavBar title={t("SubordinateRebateRatio")} />
			<div className={classes.searchNavWrap}>
				<div className="search">
					<SearchBar
						value={value}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={handleRefresh}
						placeholder={t("Search")}
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
					/>
				</div>
			</div>
			<div className={classes.searchFor}>
				<div
					onClick={() => customNavigate("/search-result")}
					className="LowerMembers"
				>
					<span>{t("LowerMembers")}</span>
				</div>
				<div
					onClick={SearchMembersListPopup.showPopup}
					className="balance"
				>
					<span>{t(bySortList[bySortValue].name)}</span>
					<DownFill color="#5E71B7" fontSize={10} />
				</div>
			</div>
			<div className="router-view">
				<div className={classes.AddMembersWrap}>
					<PullToRefresh
						onRefresh={handleRefresh}
						canReleaseText={t("canReleaseText")}
						completeText={t("completeText")}
						pullingText={t("pullingText")}
						refreshingText={t("refreshingText")}
					>
						{data.length === 0 ? (
							<CustomEmpty />
						) : (
							data.map((item, index) => (
								<div key={index}>
									<LevelChen key={index} data={item} />
								</div>
							))
						)}
						{data.length > 0 && (
							<InfiniteScroll
								loadMore={handleFetchMore}
								hasMore={hasMore}
							>
								<InfiniteScrollContent hasMore={hasMore} />
							</InfiniteScroll>
						)}
					</PullToRefresh>
				</div>
			</div>

			<SearchMembersListPopup.PopupComp
				visible={SearchMembersListPopup.visiblePopup}
				onClose={SearchMembersListPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					SearchMembersListPopup.closePopup();
				}}
			>
				<SearchMembersList
					onVisiblePopup={SearchMembersListPopup.closePopup}
					onSubmit={onSubmitHandle}
					data={bySortList}
				/>
			</SearchMembersListPopup.PopupComp>
		</div>
	);
};

export default LowerMembers;

const useStyles = createUseStyles({
	AddMembersWrap: {
		display: "flex",
		flexDirection: "column",
		padding: {
			top: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
	},
	searchNavWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(18),
		},
		borderBottom: "1px solid #2F3A62",
		"& .search": {
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
	},
	searchFor: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .LowerMembers": {
			display: "flex",
			alignItems: "center",
			color: "#FFFFFF",
			fontSize: pxToRem(16),
			fontWeight: "600",
			lineHeight: pxToRem(24),
			"& span": {
				paddingRight: pxToRem(8),
			},
		},
		"& .balance": {
			display: "flex",
			alignItems: "center",
			padding: {
				left: pxToRem(17),
				right: pxToRem(15),
			},
			width: pxToRem(160),
			height: pxToRem(36),
			borderRadius: pxToRem(40),
			border: "1px solid #2F3A62",
			"& span": {
				flex: 1,
				overflow: "hidden",
				fontSize: pxToRem(12),
				fontWeight: "400",
				color: "#FFFFFF",
			},
		},
	},
});
